import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { motion } from "framer-motion";
import { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useProfile } from "../../../contexts/ProfileContext.tsx";

function RenderBodyNomeTabela({
	nomeTable,
	row,
	handleHover,
	setLista,
	linhaSelecionada,
	showDropDowEmbarques,
	breakTd,
	contextoEmbarque,
	configEntrega
}) {
	const { tabelaUsuario } = useProfile();
	const location = useLocation();
	const getMotionProps = (colIndex) => ({
		whileHover: { backgroundColor: "#f0f8ff" },
		onHoverStart: () => {
			handleHover(colIndex);
		},
		onHoverEnd: () => {
			handleHover(null);
		},
	});

	return (
		<>
			{tabelaUsuario[nomeTable]?.map((col, colIndex) => {
				if (col.visivel === "true" || col.visivel) {
					if (
						col.field === "pedido" &&
						location.pathname === "/gerenciamento-pedido"
					) {
						if (row.pedido) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`pedido-${row.pedido}-${row.id}`}
									style={{
										color: row.corCliente,
										display: "flex",
										alignItems: "center",
										gap: "5px",
										justifyContent: "flex-start",
									}}
								>
									<input
										type="checkbox"
										onChange={(e) => {
											setLista(e.target.checked, row.idPedido);
										}}
									/>
									{row.pedido}
								</motion.td>
							);
						}
					}
					if (col.field === "usuarioResponsavel") {
						if (row.usuarioResponsavel) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`usuarioResponsavel-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{row.usuarioResponsavel.usuario}
								</motion.td>
							);
						}
					}
					if (col.field === "proprietario") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								style={{ color: row.corCliente }}
							>
								{row.proprietario}
							</motion.td>
						);
					}
					if (col.field === "veiculoMotorista") {
						if (row.veiculoMotorista) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`veiculoMotorista-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{row.veiculoMotorista.nome}
								</motion.td>
							);
						}
					}
					if (col.field === "dataHoraChegadaEmbarque") {
						if (
							row.dataHoraChegadaEmbarque === "2000-01-01T00:00:00" ||
							row.dataHoraChegadaEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraChegadaEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraChegadaEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.dataHoraChegadaEmbarque).toLocaleDateString(
										"pt-BR",
										{
											month: "numeric",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										}
									)}
								</motion.td>
							);
						}
					}
					if (col.field === "dataHoraChegadaEntrega") {
						if (
							row.dataHoraChegadaEntrega === "2000-01-01T00:00:00" ||
							row.dataHoraChegadaEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraChegadaEntrega-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraChegadaEntrega-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.dataHoraChegadaEntrega).toLocaleDateString(
										"pt-BR",
										{
											month: "numeric",
											day: "numeric",
											hour: "numeric",
											minute: "numeric",
										}
									)}
								</motion.td>
							);
						}
					}
					if (col.field === "dataHoraEntregue") {
						if (
							row.dataHoraEntregue === "2000-01-01T00:00:00" ||
							row.dataHoraEntregue === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraEntregue-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraEntregue-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.dataHoraEntregue).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.field === "dataHoraEmbarcado") {
						if (
							row.dataHoraEmbarcado === "2000-01-01T00:00:00" ||
							row.dataHoraEmbarcado === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraEmbarcado-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataHoraEmbarcado-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.dataHoraEmbarcado).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.field === "unidEmbarque") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`unidEmbarque-${row.id}`}
								style={{ color: row.corCliente }}
								className="v-entrega"
							>
								{row.entrega && row.entrega.length > 0 ? (
									<>
										{linhaSelecionada.includes(row.idEmbarque) ? (
											<KeyboardArrowUpIcon
												className="icon-entrega"
												onClick={() => {
													showDropDowEmbarques(row);
												}}
											/>
										) : (
											<KeyboardArrowDownIcon
												className="icon-entrega"
												onClick={() => {
													showDropDowEmbarques(row);
												}}
											/>
										)}

										<span>{row[col.field]}</span>
									</>
								) : (
									<span key={`unidEmbarque-${row.id}`}>{row[col.field]}</span>
								)}
							</motion.td>
						);
					}
					if (col.field === "km") {
						const kmValue = Math.trunc(parseFloat(row.km));
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`km-${row.id}`}
								style={{ color: row.corCliente }}
								className="td-right"
							>
								{isNaN(kmValue) ? 0 : kmValue}
							</motion.td>
						);
					}
					if (
						col.field === "freteFiscal" ||
						col.field === "icms" ||
						col.field === "pedagio" ||
						col.field === "classificao" ||
						col.field === "freteMotorista"
					) {
						let value;
						if (value) {
							if (typeof row[col.field] === "string") {
								value = row[col.field].replace(",", ".");
							}
							if ((value?.match(/\./g) || []).length > 1) {
								value = value.replace(".", "");
							}
							if (isNaN(parseFloat(value))) {
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`freteFiscal-${row.id}`}
										style={{ color: row.corCliente }}
										className="td-right"
									>
										{row[col.field]}
									</motion.td>
								);
							} else {
								let floatValue = parseFloat(value);
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`freteFiscal-${row.id}`}
										style={{ color: row.corCliente }}
										className="td-right"
									>
										{floatValue.toLocaleString("pt-BR", {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
										})}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "descricao") {
						if (contextoEmbarque === "templateEmbarque") {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`descricao-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{row.descricao}
								</motion.td>
							);
						} else {
							return <Fragment key={uuidv4()} />;
						}
					}
					if (col.field === "previsaoEmbarque") {
						if (
							row.previsaoEmbarque === "2000-01-01T00:00:00" ||
							row.previsaoEmbarque === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`previsaoEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`previsaoEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.previsaoEmbarque).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.field === "dataEmbarque") {
						if (row.dataEmbarque === "2000-01-01T00:00:00") {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
									className="td-center"
								>
									{new Date(row.dataEmbarque).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.field === "dataEntrega") {
						if (row.dataEntrega === "2000-01-01T00:00:00") {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataEntrega-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`dataEntrega-${row.id}`}
									style={{ color: row.corCliente }}
									className="td-center"
								>
									{new Date(row.dataEntrega).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.field === "previsaoEntrega") {
						if (
							row.previsaoEntrega === "2000-01-01T00:00:00" ||
							row.previsaoEntrega === null
						) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`previsaoEntrega-${row.id}`}
									style={{ color: row.corCliente }}
								/>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`previsaoEntrega-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{new Date(row.previsaoEntrega).toLocaleDateString("pt-BR", {
										month: "numeric",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
									})}
								</motion.td>
							);
						}
					}
					if (col.objetoUnidadeEmbarque === "true") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`objetoUnidadeEmbarque-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{row.cidadeEstado.cidade}
							</motion.td>
						);
					}
					if (col.field === "embarcadorEstado") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`embarcadorEstado-${row.id}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.embarcadorEstado}
							</motion.td>
						);
					}
					if (col.field === "destinatarioEstado") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`destinatarioEstado-${row.id}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{row.destinatarioEstado}
							</motion.td>
						);
					}
					if (col.field === "permissoes") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`permissoes-${row.id}`}
								style={{ color: row.corCliente }}
							>{`${row.regras},`}</motion.td>
						);
					}
					if (col.field === "nascimento") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`nascimento-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{new Date(row.nascimento).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "ultimoLogin" && row.ultimoLogin !== null) {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`ultimoLogin-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{new Date(row.ultimoLogin).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
									hour: "numeric",
									minute: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "ultimoLogout" && row.ultimoLogout !== null) {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`ultimoLogout-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{new Date(row.ultimoLogout).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
									hour: "numeric",
									minute: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "data") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`data-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{new Date(row.data).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "mensagem") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`mensagem-${row.id}`}
								style={{ color: row.corCliente }}
								className={breakTd ? breakTd : ""}
							>
								{row.mensagem}
							</motion.td>
						);
					}
					if (col.objetoUnidadeEmbarque === "true") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`objetoUnidadeEmbarque-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{row.cidadeEstado.cidade}
							</motion.td>
						);
					}
					if (col.objetoValorEmbarque === "true") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`objetoValorEmbarque-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{row.valorEmbarque?.rota?.nome}
							</motion.td>
						);
					}
					if (col.visivel === "true" || col.visivel) {
						if (
							col.field === "valorEmbarque" ||
							col.field === "permiteAlterarFreteFiscal" ||
							col.field === "icmsEmbutido" ||
							col.field === "icmsEmbarcador"
						) {
							if (row[col.field] === true) {
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`valorEmbarque-${row.id}-${colIndex}`}
										style={{ color: row.corCliente }}
									>
										Sim
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`valorEmbarque-${row.id}-${colIndex}`}
										style={{ color: row.corCliente }}
									>
										Não
									</motion.td>
								);
							}
						}
						if (col.objetoUnidadeEmbarque === "true") {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`objetoUnidadeEmbarque-${row.id}`}
									style={{ color: row.corCliente }}
								>
									{row.cidadeEstado.cidade}
								</motion.td>
							);
						} else {
							if (!isNaN(parseFloat(row[col.field ?? 0]))) {
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`valorEmbarque-${row.id}-${colIndex}`}
										style={{ color: row.corCliente }}
										className="td-right"
									>
										{row[col.field ?? 0]}
									</motion.td>
								);
							} else {
								return (
									<motion.td
										{...getMotionProps(colIndex)}
										key={`valorEmbarque-${row.id}-${colIndex}`}
										style={{ color: row.corCliente }}
									>
										{row[col.field ?? 0]}
									</motion.td>
								);
							}
						}
					}
					if (col.field === "notificarACadaData") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`notificarACadaData-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{row.notificarACadaData}
							</motion.td>
						);
					}
					if (col.field === "tipoCheck") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`tipoCheck-${row.id}`}
								style={{ color: row.corCliente }}
							>
								{row.tipoCheck.nome}
							</motion.td>
						);
					}
					if (col.field === "dataCheckagem") {
						return (
							<motion.td
								{...getMotionProps(colIndex)}
								key={`dataCheckagem-${row.id}`}
								style={{ color: row.corCliente }}
								className="td-center"
							>
								{new Date(row.dataCheckagem).toLocaleDateString("pt-BR", {
									year: "numeric",
									month: "numeric",
									day: "numeric",
								})}
							</motion.td>
						);
					}
					if (col.field === "proximaRevisaoData") {
						if (row.proximaRevisaoData === null) {
							<motion.td
								{...getMotionProps(colIndex)}
								key={`proximaRevisaoData-${row.id}`}
								style={{ color: row.corCliente }}
							/>;
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`proximaRevisaoData-${row.id}`}
									style={{ color: row.corCliente }}
									className="td-center"
								>
									{new Date(row.proximaRevisaoData).toLocaleDateString(
										"pt-BR",
										{
											year: "numeric",
											month: "numeric",
											day: "numeric",
										}
									)}
								</motion.td>
							);
						}
					}
					if (col.field === "notificarAutomatico") {
						if (row.notificarAutomatico === true) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`notificarAutomatico-${row.id}`}
									style={{ color: row.corCliente }}
								>
									Sim
								</motion.td>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`notificarAutomatico-${row.id}`}
									style={{ color: row.corCliente }}
								>
									Não
								</motion.td>
							);
						}
					}
					if (col.field === "frota") {
						if (row.frota === true) {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`frota-${row.id}`}
									style={{ color: row.corCliente }}
								>
									Sim
								</motion.td>
							);
						} else {
							return (
								<motion.td
									{...getMotionProps(colIndex)}
									key={`frota-${row.id}`}
									style={{ color: row.corCliente }}
								>
									Não
								</motion.td>
							);
						}
					}
					return <Fragment key={uuidv4()} />;
				} else {
					return <Fragment key={uuidv4()} />;
				}
			})}
		</>
	);
}

export default RenderBodyNomeTabela;
